const SENSITIVE_ROUTE_PREFIXES = ["/tenant/billing"] as const;

const SENSITIVE_QUERY_KEYS = [
  "access",
  "invitation",
  "checkout",
  "recovery",
] as const;

export function isSensitiveRoute(pathname: string | null | undefined) {
  if (!pathname) return false;
  return SENSITIVE_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function analyticsSafePath(
  pathname: string,
  searchParams: URLSearchParams,
) {
  if (isSensitiveRoute(pathname)) return pathname;

  const safeParams = new URLSearchParams(searchParams);
  for (const key of SENSITIVE_QUERY_KEYS) safeParams.delete(key);
  const queryString = safeParams.toString();
  return queryString ? `${pathname}?${queryString}` : pathname;
}
